import { httpClient } from "../../httpClient";
import { LandingZoneRoleModel } from "@api/types/landingzoneroles";

type Data = {
  landingZoneRoles: LandingZoneRoleModel[];
};

const landingZoneRolesRoute = "/api/v1/landing-zone-roles";

export async function getLandingZoneRoles(): Promise<LandingZoneRoleModel[]> {
  try {
    const { data } = await httpClient.get<Data>(landingZoneRolesRoute);
    return data.landingZoneRoles;
  } catch (err) {
    throw err;
  }
}

export async function postLandingZoneRole(payload: LandingZoneRoleModel) {
  try {
    const { data } = await httpClient.post(landingZoneRolesRoute, payload);
    return data;
  } catch (err) {
    throw err;
  }
}

export async function putLandingZoneRole(payload: LandingZoneRoleModel) {
  try {
    const { data } = await httpClient.put(landingZoneRolesRoute, payload);
    return data;
  } catch (err) {
    throw err;
  }
}
